var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDenemeSinavlari(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 9,
    fill: "url(#paint0_linear_1686_759)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.90901 7.40901C9.33097 6.98705 9.90326 6.75 10.5 6.75H16.875C17.0739 6.75 17.2647 6.82902 17.4053 6.96967L21.5303 11.0947C21.671 11.2353 21.75 11.4261 21.75 11.625V21C21.75 21.5967 21.5129 22.169 21.091 22.591C20.669 23.0129 20.0967 23.25 19.5 23.25H10.5C9.90326 23.25 9.33097 23.0129 8.90901 22.591C8.48705 22.169 8.25 21.5967 8.25 21V9C8.25 8.40326 8.48705 7.83097 8.90901 7.40901ZM10.5 8.25C10.3011 8.25 10.1103 8.32902 9.96967 8.46967C9.82902 8.61032 9.75 8.80109 9.75 9V21C9.75 21.1989 9.82902 21.3897 9.96967 21.5303C10.1103 21.671 10.3011 21.75 10.5 21.75H19.5C19.6989 21.75 19.8897 21.671 20.0303 21.5303C20.171 21.3897 20.25 21.1989 20.25 21V11.9357L16.5643 8.25H10.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 6.75C16.9142 6.75 17.25 7.08579 17.25 7.5V11.25H21C21.4142 11.25 21.75 11.5858 21.75 12C21.75 12.4142 21.4142 12.75 21 12.75H16.5C16.0858 12.75 15.75 12.4142 15.75 12V7.5C15.75 7.08579 16.0858 6.75 16.5 6.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7803 15.2197C18.0732 15.5126 18.0732 15.9874 17.7803 16.2803L14.7803 19.2803C14.4874 19.5732 14.0126 19.5732 13.7197 19.2803L12.2197 17.7803C11.9268 17.4874 11.9268 17.0126 12.2197 16.7197C12.5126 16.4268 12.9874 16.4268 13.2803 16.7197L14.25 17.6893L16.7197 15.2197C17.0126 14.9268 17.4874 14.9268 17.7803 15.2197Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1686_759",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CD88D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DBE87"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDenemeSinavlari);
export default __webpack_public_path__ + "static/media/deneme-sinavlari.35711ba71ff820a169ecd63f1eed7079.svg";
export { ForwardRef as ReactComponent };